// extracted by mini-css-extract-plugin
module.exports = {"bb-content-overview":"bb-content-overview__bKIQJ"};